import {
  SlDrawer,
  SlTooltip,
  SlIcon,
  SlSelect,
  SlOption,
  SlTabGroup,
  SlTab,
  SlTabPanel,
  SlDetails,
} from "@shoelace-style/shoelace/dist/react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import config from "../../config";
import ScrollContainer from "react-indiana-drag-scroll";
import { roles } from "../../utils/constants";
import { formatDate, formatDateWithTime } from "../../utils/dateFormat";
import Paginator from "../../shared/Paginator";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useNavigate } from "react-router";
import Datepicker from "react-tailwindcss-datepicker";

function Help() {
  const navigate = useNavigate();

  const form2 = useForm({
    mode: "onSubmit",
  });
  const form3 = useForm({
    mode: "onSubmit",
  });

  const watchUpdate = form2.watch("description");
  const watchReason = form3.watch("update");
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }

  const defaultDateRange = useMemo(() => {
    const formatDateInput = (date) => date.toISOString().split("T")[0];
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - 6);
    return {
      startDate: formatDateInput(start),
      endDate: formatDateInput(end),
    };
  }, []);
  const [loader, setLoader] = useState(false);
  const [currentpage, setCurrentPage] = useState(0);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [previewMedia, setPreviewMedia] = useState(null);
  const [data, setData] = useState([]);
  const [preview, setPreview] = useState(false);
  const [helpData, setHelpData] = useState(null);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [showUpdates, setShowUpdates] = useState(false);
  const [updates, setUpdates] = useState([]);
  const [status, setStatus] = useState("all");
  const [type, setType] = useState("all");
  const [totalPages, setTotalPages] = useState(0);
  const [deleteClicked, setDeleteClicked] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [activeTab, setActiveTab] = useState("all");
  const [dateRange, setDateRange] = useState(defaultDateRange);
  const [dateWiseReport, setDatewiseReport] = useState([]);
  const [copiedImageId, setCopiedImageId] = useState(null);
  const copyResetTimer = useRef(null);
  const dateWiseTotals = useMemo(
    () =>
      dateWiseReport.reduce(
        (acc, report) => ({
          pending: acc.pending + (Number(report.pending) || 0),
          progress: acc.progress + (Number(report.progress) || 0),
          resolved: acc.resolved + (Number(report.resolved) || 0),
          ignore: acc.ignore + (Number(report.ignore) || 0),
          total: acc.total + (Number(report.total) || 0),
        }),
        { pending: 0, progress: 0, resolved: 0, ignore: 0, total: 0 }
      ),
    [dateWiseReport]
  );
  const statusMappings = {
    1: "Pending",
    2: "In Progress",
    3: "Resolved",
    4: "Ignore",
  };

  const typeMappings = {
    1: "Category",
    2: "Location",
    3: "Brand Merging",
    4: "Pricing",
    5: "Adtype",
    6: "Page",
  };

  useEffect(() => {
    return () => {
      if (copyResetTimer.current) clearTimeout(copyResetTimer.current);
    };
  }, []);

  const loadData = async (page = currentpage) => {
    if(activeTab === 'dateWise') return
    setLoader(true);
    try {
      let res = await API({
        url: "/help/get",
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          status,
          type,
          ...(dateRange?.startDate &&
            dateRange?.endDate && {
              start_date: dateRange.startDate,
              end_date: dateRange.endDate,
            }),
        },
      });
      if (res.code === 200) {
        setData(res.data?.data);
        setTotalPages(Math.round(res.data?.totals / config.PER_PAGE));
        setCurrentPage(page);
      } else if (res.code === 401) navigate("/");
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };
  const handlePreview = (url) => {
    const type = url.split(".")?.pop();
    setPreviewMedia({
      url: url,
      type: type === "mp4" ? "video" : "image",
    });
    setPreview(true);
  };
  const handleUpdateHelp = async (data) => {
    setSubmitLoader(true);
    try {
      let res = await API({
        url: "/help/update",
        method: "POST",
        responseType: "json",
        data: {
          id: helpData.id,
          status: data.status,
          update: data.description,
          data: helpData,
        },
      });
      if (res.code === 200) {
        setUpdateStatus(false);
        setHelpData(null);
        loadData();
        form2.reset();
      }
    } catch (error) {
    } finally {
      setSubmitLoader(false);
    }
  };
  const handleIgnore = async (data) => {
    setSubmitLoader(true);
    try {
      let res = await API({
        url: "/help/ignore",
        method: "POST",
        responseType: "json",
        data: {
          id: deleteId,
          update: data.update,
          status: 4,
        },
      });
      if (res.code === 200) {
        loadData();
        setDeleteClicked(false);
        setDeleteId(null);
        form3.reset();
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Someting went wrong");
    } finally {
      setSubmitLoader(false);
    }
  };

  const handleCopyImage = async (url, key) => {
    try {
      await navigator.clipboard.writeText(url || "");
      setCopiedImageId(key);
      if (copyResetTimer.current) clearTimeout(copyResetTimer.current);
      copyResetTimer.current = setTimeout(() => setCopiedImageId(null), 2000);
    } catch (error) {
      Toast("error", "Failed to copy");
    }
  };
  useEffect(() => {
    loadData(0);
    setCurrentPage(0)
  }, [status, type, activeTab]);

  useEffect(() => {
    loadData(0);
    setCurrentPage(0)
  }, [dateRange?.startDate, dateRange?.endDate]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    loadData(event.selected);
  };

  const loadDateWise = async()=>{
    setLoader(true)
    try {
      let res = await API({
        url:'/help/datewise',
        method:'POST',
        responseType:'json',
        data:{
            dateRange
        }
      })
      if(res.code === 200){
        setDatewiseReport(res.data)
      }
    } catch (error) {
      console.error(error, "Error at loadDatewise")
    }finally{
      setLoader(false)
    }
  }

  useEffect(()=>{
    if(activeTab === 'dateWise'){
      loadDateWise()
    }
  },[activeTab, dateRange])

  const PageRateDetails = ({ item }) => {
    if (item?.record_type !== "PageRates") return null;
    return (
      <div className="flex flex-col gap-1 text-sm leading-5">
        <p>NewsPaper : {item?.newspaper_name?.toUpperCase() || "-"}</p>
        <p>LocationType : {item?.location_type?.toUpperCase() || "-"}</p>
        <p>Location: {item?.location?.toUpperCase() || "-"}</p>
        <p>Page Type: {item?.page_type?.toUpperCase() || "-"}</p>
        <p>Ad Type: {item?.ad_type?.toUpperCase() || "-"}</p>
        <p>AdSize: {item?.ad_size?.toUpperCase() || "-"}</p>
        <p>Color Price: {item?.price || "-"}</p>
        <p>BW Price: {item?.bw_price || "-"}</p>
      </div>
    );
  };
  return (
    <>
      <h5 className="my-2">Tickets</h5>
      <SlTabGroup
        className="mt-3"
        onSlTabShow={(event) => {
          setActiveTab(event.detail.name);
          setCurrentPage(0);
        }}
      >
        <SlTab slot="nav" panel="all">
          All issues
        </SlTab>
        <SlTab slot="nav" panel="dateWise">
          Date wise
        </SlTab>

        <SlTabPanel name="all">
          <div className="justify-end flex my-2">
            <aside className="flex gap-3 items-end">
              <div className="flex flex-col">
                <label className="text-sm text-slate-700">Date range</label>
                <Datepicker
                  value={dateRange}
                  onChange={(val) =>
                    setDateRange(val || defaultDateRange)
                  }
                  useRange
                  asSingle={false}
                  primaryColor="slate"
                  popoverDirection="down"
                  readOnly={false}
                  showShortcuts={true}
                  toggleClassName="hidden"
                  containerClassName="w-full relative min-w-[240px]"
                  inputClassName="form-control"
                  displayFormat="DD/MM/YYYY"
                />
              </div>
              <SlSelect
                label="Type"
                value={type}
                className="min-w-[120px]"
                onSlChange={(e) => setType(e.target.value)}
                size="small"
              >
                <SlOption value="all">All</SlOption>
                <SlOption value={1}>Cateory</SlOption>
                <SlOption value={2}>Location</SlOption>
                <SlOption value={3}>Brand Merging</SlOption>
                <SlOption value={4}>Pricing</SlOption>
                <SlOption value={5}>Ad Type</SlOption>
                <SlOption value={6}>Page</SlOption>
              </SlSelect>
              <SlSelect
                label="Status"
                value={status}
                onSlChange={(e) => setStatus(e.target.value)}
                size="small"
              >
                <SlOption value="all">All</SlOption>
                <SlOption value={1}>Pending</SlOption>
                <SlOption value={2}>In Progress</SlOption>
                <SlOption value={3}>Resolved</SlOption>
                <SlOption value={4}>Ignore</SlOption>
              </SlSelect>
            </aside>
          </div>
          <ScrollContainer>
            <table className="table table-bordered">
              <thead className="bg-gray-50">
                <tr>
                  <th>S.No</th>
                  <th>Type</th>
                  <th>Brand</th>
                  <th>Campaign Name</th>
                  <th>Image Url</th>
                  <th>Description</th>
                  <th>Ad Published Date</th>
                  <th>Created Date</th>
                  <th>Created by</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              {!loader && data.length > 0 ? (
                <tbody className="help">
                  {data.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{typeMappings[item.type]}</td>
                      <td>{item.brand_name || ""}</td>
                      <td>{item.campaign_name}</td>
                      <td>
                        <SlIcon
                          library="lucide"
                          name={
                            copiedImageId === (item.id ?? index) ? "check" : "copy"
                          }
                          className="cursor-pointer w-4 h-4 hover:text-sky-300"
                          onClick={() =>
                            handleCopyImage(item.image_url, item.id ?? index)
                          }
                        />
                      </td>
                      <td
                        title={item.description}
                        className="break-words !whitespace-normal max-w-sm line-clamp"
                      >
                        {item.description}
                        {item.record_type === "PageRates" ? (
                          <SlDetails summary="Page rate details" className="mt-1">
                            <PageRateDetails item={item} />
                          </SlDetails>
                        ) : null}
                      </td>
                      <td>{formatDate(item.birdview_date)}</td>
                      <td>{formatDate(item.created_on)}</td>
                      <td>{item.name}</td>
                      <td>
                        <span
                          className={`px-2 py-1 rounded-md  ${
                            item.status === 1
                              ? "bg-yellow-300 text-black"
                              : item.status === 2
                              ? "bg-blue-300 !text-blue-800"
                              : item.status === 3
                              ? "bg-green-300 !text-green-900"
                              : "bg-gray-400 !text-gray-800"
                          } `}
                        >
                          {item.status === 1
                            ? "Pending"
                            : item.status === 2
                            ? "In Progress"
                            : item.status === 3
                            ? "Resolved"
                            : "Ignore"}
                        </span>
                      </td>
                      <td>
                        <div className="flex gap-3">
                          <SlTooltip content="preview">
                            <SlIcon
                              name="eye"
                              className="cursor-pointer w-4 h-4 hover:text-sky-300"
                              library="lucide"
                              onClick={() =>
                                handlePreview(item.media_url || item.image_url)
                              }
                            ></SlIcon>
                          </SlTooltip>
                          {localStorage.getItem("role") === roles.salesperson &&
                            item.status !== 3 &&
                            item.status !== 4 && (
                              <SlTooltip content="Delete">
                                <SlIcon
                                  name="trash-2"
                                  className="cursor-pointer w-4 h-4 hover:text-red-500"
                                  //   size="16"
                                  onClick={() => {
                                    setDeleteId(item.id);
                                    setDeleteClicked(true);
                                  }}
                                  library="lucide"
                                />
                              </SlTooltip>
                            )}
                          {localStorage.getItem("role") === roles.b2b && (
                            <SlTooltip content="Edit">
                              <SlIcon
                                name="edit"
                                className="cursor-pointer w-4 h-4 hover:text-sky-300"
                                onClick={() => {
                                  setUpdateStatus(true);
                                  form2.setValue("status", item.status);
                                  setHelpData(item);
                                }}
                                //   size="16"
                                library="lucide"
                              />
                            </SlTooltip>
                          )}
                          <SlTooltip content="View Updates">
                            <SlIcon
                              name="bell"
                              className="cursor-pointer w-4 h-4 hover:text-sky-300"
                              onClick={() => {
                                setShowUpdates(true);
                                setHelpData(item);
                                setUpdates(item.updates);
                              }}
                              library="lucide"
                            />
                          </SlTooltip>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : loader ? (
                <TableSkelton colspan={11} />
              ) : (
                <NoDataFound colspan={11} />
              )}
            </table>
          </ScrollContainer>
          <div className=" right-fixed mt-4">
            {totalPages > 1 && (
              <Paginator
                pageCount={totalPages}
                handlePageClick={handlePageClick}
                forcePage={currentpage}
              />
            )}
          </div>
        </SlTabPanel>

        <SlTabPanel name="dateWise">
          <div className="p-4 border rounded bg-white shadow-sm space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex flex-col gap-1">
                <label className="text-sm text-slate-700">Date range</label>
                <Datepicker
                  value={dateRange}
                  onChange={(val) =>
                    setDateRange(val || defaultDateRange)
                  }
                  useRange
                  asSingle={false}
                  primaryColor="slate"
                  popoverDirection="down"
                  readOnly={false}
                  showShortcuts={true}
                  toggleClassName="hidden"
                  containerClassName="w-full relative"
                  inputClassName="form-control"
                  displayFormat="DD/MM/YYYY"
                />
              </div>
            </div>
            <ScrollContainer>
              <table className="table table-bordered">
                <thead className="bg-gray-100">
                  <tr>
                    <th>S.No</th>
                    <th>Date</th>
                    <th>Pending</th>
                    <th>In Progress</th>
                    <th>Resolved</th>
                    <th>Ignored</th>
                    <th>Total</th>
                  </tr>
                </thead>
                {dateWiseReport.length > 0 && !loader ? (
                  <tbody>
                    {dateWiseReport.map((report, idx) => (
                      <tr>
                        <td>{idx + 1}</td>
                        <td>{(report.date)}</td>
                        <td>{report.pending}</td>
                        <td>{report.progress}</td>
                        <td>{report.resolved}</td>
                        <td>{report.ignore}</td>
                        <td>{report.total}</td>
                      </tr>
                    ))}
                  </tbody>
                ) : loader ? (
                  <TableSkelton colspan={7} />
                ) : (
                  <NoDataFound colspan={7} />
                )}
                <tfoot>
                  <tr>
                    <td className="!bg-gray-100" colSpan={2}>Total</td>
                    <td>{dateWiseTotals.pending}</td>
                    <td>{dateWiseTotals.progress}</td>
                    <td>{dateWiseTotals.resolved}</td>
                    <td>{dateWiseTotals.ignore}</td>
                    <td>{dateWiseTotals.total}</td>
                  </tr>
                </tfoot>
              </table>
            </ScrollContainer>
          </div>
        </SlTabPanel>
      </SlTabGroup>

      {preview && (
        <SlDrawer
          label="preview"
          onSlRequestClose={handleRequestClose}
          open={preview}
          onSlAfterHide={() => {
            setPreview(false);
            setPreviewMedia(null);
          }}
        >
          {previewMedia ? (
            previewMedia.type === "image" ? (
              <img
                src={previewMedia.url}
                alt="Preview"
                className="w-full max-h-96 rounded border"
              />
            ) : (
              <video
                src={previewMedia.url}
                controls
                className="w-full h-auto rounded border"
              />
            )
          ) : (
            <p className="text-gray-500">No media selected</p>
          )}
        </SlDrawer>
      )}
      {updateStatus && (
        <SlDrawer
          label="Update"
          open={updateStatus}
          onSlRequestClose={handleRequestClose}
          onSlAfterHide={() => {
            setHelpData(null);
            setUpdateStatus(false);
            form2.reset();
          }}
          style={{'--size':"50vw"}}
        >
          <div className="flex gap-3">
            <div className="w-1/2">
              <img src={helpData.image_url} alt="ad-image" />
              <h5>{helpData.campaign_name}</h5>
              <p>Date : {formatDate(helpData.birdview_date)}</p>
            </div>
          <form className="w-1/2" onSubmit={form2.handleSubmit(handleUpdateHelp)}>
            <div className="mb-3">
              <label className="form-label font-semibold" htmlFor="description">
                Description
              </label>
              <p>{helpData?.description}</p>
              {helpData?.record_type === "PageRates" ? (
                <div className="mt-2">
                  <PageRateDetails item={helpData} />
                </div>
              ) : null}
            </div>
            <div className="mb-3">
              <label className="form-label" htmlFor="Status">
                Status
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                {...form2.register("status", { required: true })}
              >
                <option value="1">Pending</option>
                <option value="2">In Progress</option>
                <option value="3">Resolved</option>
                <option value="4">Ignore</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label" htmlFor="update">
                Update
              </label>
              <span className="text-red-600">*</span>&nbsp;&nbsp;{" "}
              <span
                className={`${
                  watchUpdate?.length > 100 ? "text-red-600" : "text-green-500"
                }`}
              >
                {100 - watchUpdate?.length || 100}
              </span>
              <textarea
                className="form-control"
                id="update"
                rows="3"
                {...form2.register("description", {
                  required: true,
                  minLength: 1,
                  maxLength: 100,
                })}
              ></textarea>
              {form2.formState?.errors?.description?.type === "maxLength" && (
                <p className="text-red-600">Too many Characthers</p>
              )}
              {form2.formState?.errors?.description
                ? form2.formState?.errors?.description?.type !==
                    "maxLength" && (
                    <p className="text-red-600">Please Enter Update</p>
                  )
                : null}
            </div>
            <div className="mb-3">
              <button className="btn btn-primary w-full" type="submit">
                {submitLoader && (
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
                {submitLoader ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
          </div>
        </SlDrawer>
      )}

      {showUpdates && (
        <SlDrawer
          label="Updates"
          onSlRequestClose={handleRequestClose}
          open={showUpdates}
          onSlAfterHide={() => {
            setShowUpdates(false);
          }}
        >
          <>
            <div className="flex flex-col gap-3">
              <div className="max-w-md p-4 border rounded-lg shadow-lg bg-white">
                <div className="flex justify-between items-center mb-3">
                  <span className="text-sm font-medium text-gray-600">
                    {formatDateWithTime(helpData.created_on)}
                  </span>
                  <span
                    className={`px-3 py-1 text-xs font-bold rounded-full 
                     bg-yellow-300 text-black`}
                  >
                    Pending
                  </span>
                </div>

                <p className="text-sm text-gray-500 mb-3">
                  👤 Created By:{" "}
                  <span className="font-medium text-gray-700">
                    {helpData.name}
                  </span>
                </p>
                <p className="text-gray-700">{helpData.description}</p>
              </div>
            </div>
            {updates?.map((update) => (
              <div className="flex flex-col gap-3">
                <div className="max-w-md p-4 border rounded-lg shadow-lg bg-white">
                  <div className="flex justify-between items-center mb-3">
                    <span className="text-sm font-medium text-gray-600">
                      {formatDateWithTime(update.updated_on)}
                    </span>
                    <span
                      className={`px-3 py-1 text-xs font-bold rounded-full 
                     ${
                       update.status === "1"
                         ? "bg-yellow-300 text-black"
                         : update.status === "2"
                         ? "bg-blue-300 !text-blue-800"
                         : update.status === "3"
                         ? "bg-green-300 !text-green-900"
                         : "bg-gray-400 !text-gray-800"
                     }`}
                    >
                      {statusMappings[update.status]}
                    </span>
                  </div>

                  <p className="text-sm text-gray-500 mb-3">
                    👤 Updated By:{" "}
                    <span className="font-medium text-gray-700">
                      {update.updated_by}
                    </span>
                  </p>
                  <p className="text-gray-700">{update.update}</p>
                </div>
              </div>
            ))}
          </>
        </SlDrawer>
      )}
      {deleteClicked && (
        <Modal
          show={deleteClicked}
          backdrop="static"
          animation={false}
          centered
          onHide={() => {
            setDeleteClicked(false);
            setDeleteId(null);
            form3.reset();
          }}
        >
          <ModalHeader closeButton>
            <ModalTitle>Ignore the issue / Misrepresentation</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <form onSubmit={form3.handleSubmit(handleIgnore)}>
              <div className="mb-3">
                <label htmlFor="update" className="form-label">
                  Reason
                </label>
                <span className="text-red-600">*</span>&nbsp;&nbsp;
                <span
                  className={`${
                    watchReason?.length > 100
                      ? "text-red-600"
                      : "text-green-500"
                  }`}
                >
                  {100 - watchReason?.length || 100}
                </span>
                <textarea
                  className="form-control"
                  rows={2}
                  {...form3.register("update", {
                    required: true,
                    minLength: 1,
                    maxLength: 100,
                  })}
                ></textarea>
                {form3.formState?.errors?.update?.type === "maxLength" && (
                  <p className="text-red-600">Too many Characthers</p>
                )}
                {form3.formState?.errors?.update
                  ? form3.formState?.errors?.update?.type !== "maxLength" && (
                      <p className="text-red-600">Reason is required</p>
                    )
                  : null}
              </div>
              <div className="mb-3">
                <button type="submit" className="btn btn-primary w-full">
                  {submitLoader && (
                    <span
                      className="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  {submitLoader ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </ModalBody>
        </Modal>
      )}
    </>
  );
}

export default Help;
